/*
 *This function is a hack for any video page to trigger click
 * event to show Optanon Privacy Modal (do not sell)
 * dependency on the internals of a 3rd party package and could break if the 3rd party break
 */

const setVideoPrivacyModalHandler = () => {
    let elements = document.querySelectorAll('a.ot-sdk-show-settings');
    if (elements) {
        elements.forEach((element) => {
            element.setAttribute('href', '#');
            element.addEventListener('click', function (e) {
                e.preventDefault();
                //dependency on the internals of a 3rd party package and could break if the 3rd party break
                globalThis.Optanon.ToggleInfoDisplay();
            });
        });
    }
};

export default setVideoPrivacyModalHandler;
